<script lang="ts">  import { m } from '$lib/paraglide/messages';

  import type { Track } from '$lib/models/track';
  import Waveform from './waveform.svelte';
  import { player } from '$lib/stores/player';
  import { translation } from '$lib/locale/locale';
  import { progressToTime, timeNormalized, timeToSeconds } from '$lib/utils/time';
  import pauseIcon from '$lib/assets/shared/play/pause-white-no-background.svg';
  import playIcon from '$lib/assets/shared/play/play-white-no-background.svg';
  import { AssetType } from '$lib/utils/asset';
  import Spinner from '../shared/spinner.svelte';

  const {} = translation();
  export let asset: Track;

  let playing = false;
  let progress = 0;
  let loadingAudio = false;

  $: if ($player.id === asset.id) {
    progress = $player.progress;
    playing = $player.status === 'playing';
    loadingAudio = $player.status === 'loading';
  } else {
    progress = 0;
    playing = false;
    loadingAudio = false;
  }
</script>

<div class="player-container">
  <div class="wave-container">
    {#if loadingAudio}
      <div class="loader">
        <Spinner size="24px" slim={true} />
      </div>
    {:else if playing}
      <button on:click={() => player.pause()}>
        <img src={pauseIcon} class="play-pause" alt={m['actions.pause']()} loading="lazy" />
      </button>
    {:else if !playing && $player.id === asset.id}
      <button on:click={() => player.resume()}>
        <img src={playIcon} class="play-pause" alt={m['actions.play']()} loading="lazy" />
      </button>
    {:else}
      <button on:click={() => player.play(asset)}>
        <img src={playIcon} class="play-pause" alt={m['actions.play']()} loading="lazy" />
      </button>
    {/if}
    <div class="time">{progressToTime(progress, asset.duration)}</div>
    <div class="wave">
      <Waveform
        data={asset.waveform ?? []}
        {progress}
        height={45}
        duration={timeToSeconds(asset.duration)}
        seekerColor="#FFFFFF"
        color="#647281"
        on:seek={(e) => player.play(asset, e.detail)}
      />
    </div>
    <div class="time">{timeNormalized(asset.duration)}</div>
  </div>
</div>

<style>
  .player-container {
    display: flex;
    padding: 24px 20px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 24px;
    border-radius: 8px;
    width: 100%;
    height: 68px;
    color: var(--text-invert-secondary);
    background-color: #1e2226;
  }

  .wave-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .wave {
    flex: 1;
    margin-right: 24px;
    margin-left: 24px;
  }

  .play-pause {
    width: 24px;
    height: 24px;
    margin-right: 18px;
  }
  .loader {
    width: 24px;
    height: 24px;
    margin-right: 18px;
    display: flex;
  }
  .time {
    width: 50px;
    text-align: center;
    color: var(--text-invert-secondary);
    font-size: var(--base-font-size);
    font-weight: var(--normal-font-weight);
  }

  @media (max-width: 1100px) {
    .play-pause {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }

    .wave {
      margin-right: 10px;
      margin-left: 10px;
    }

    .time {
      width: 40px;
      font-size: var(--xxs-font-size);
    }
  }
</style>
